export const FIll_DETAILS="FIll_DETAILS"
export const GET_RESTAURANT_LIST="GET_RESTAURANT_lIST"
export const GET_OCCASION_LIST="GET_OCCASION_LIST"
export const BOOK_TABLE_NOW="BOOK_TABLE_NOW"